import hashSum from 'hash-sum';
import { useFormApi, useFormState } from 'informed';
import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';

import SelectAllCheckbox from './SelectAllCheckbox';

export const setSelectAllField = (fieldId) =>
  hashSum(`${fieldId}-select-all-field`);

const SelectAllGroup = ({ fieldId, selectAllLabel }) => {
  const [checkState, setCheckState] = useState(false);
  const formState = useFormState();
  const formApi = useFormApi();

  const SELECT_ALL_FIELD = setSelectAllField(fieldId);

  /*
    Return true if the field isn't the select all field
  */
  const isFieldInGroup = useCallback(
    (field) => field !== SELECT_ALL_FIELD && field !== fieldId,
    [fieldId, SELECT_ALL_FIELD],
  );

  // formApi.emitter.fields is a Map & the only place to get fields not in state
  const allGroupFields = [...formApi.emitter.fieldsById].reduce(
    (arr, value) => {
      if (isFieldInGroup(value[1].field)) {
        arr.push(value[1].field);
      }
      return arr;
    },
    [],
  );

  useEffect(() => {
    if (formState.values) {
      const selectedFields = Object.entries(formState.values).filter(
        ([key, isChecked]) => isFieldInGroup(key) && isChecked,
      );
      if (selectedFields.length === allGroupFields.length) {
        setCheckState(true);
      } else if (selectedFields.length) {
        setCheckState('mixed');
      } else {
        setCheckState(false);
      }
    }
  }, [allGroupFields.length, isFieldInGroup, formState]);

  const handleSelectAllChange = (e) => {
    allGroupFields.forEach((field) => {
      formApi.setValue(field, e.target.checked);
    });
  };

  return (
    <SelectAllCheckbox
      checkState={checkState}
      formApi={formApi}
      label={selectAllLabel}
      onChange={handleSelectAllChange}
      selectAllField={SELECT_ALL_FIELD}
    />
  );
};

SelectAllGroup.defaultProps = {
  selectAllLabel: 'Select All',
};

SelectAllGroup.propTypes = {
  fieldId: PropTypes.string.isRequired,
  selectAllLabel: PropTypes.string,
};

export default SelectAllGroup;
